
<scroll-area class="work-area workarea">
  <template v-for="item in objectModel.propertiesAndPropertySections">
    <template v-if="item instanceof ObjectModelProperty">
      <base-object-model-property
        :object-model-property="item"
        :key="item.client_id"
      />
    </template>
    <template v-else>
      <property-section-builder-element
        :property-section="item"
        :key="item.client_id"
      />
    </template>
  </template>

  <div v-if="isEmpty" class="drop-in-zone empty">
    <p><b>Drag and Drop</b> property types here</p>
  </div>
</scroll-area>
